import { createSlice } from "@reduxjs/toolkit"
import { getSideBarCollapsedFromLocalStorage } from "../../../../hooks/useLocalStorage"

type InitialState = {
  sidebarCollapsed: boolean
}

const initialStateValue: InitialState = {
  sidebarCollapsed: getSideBarCollapsedFromLocalStorage()
}

const slice = createSlice({
  name: "ui",
  initialState: initialStateValue,
  reducers: {
    setSidebarCollapsed(state, action) {
      state.sidebarCollapsed = action.payload
      try {
        localStorage.setItem("merchant-portal_sidebar-collapsed", JSON.stringify(action.payload))
      } catch (error) {
        console.error("Failed to save sidebar state to localStorage:", error)
      }
    }
  }
})

const { actions, reducer } = slice
export const { setSidebarCollapsed } = actions

export default reducer
